import { useStyletron } from '@olxeu-jobs/ui';
import { ResponsiveImage } from '~features/fapollo';
import fallbackLight from './fallback-light.svg';
import { FallbackImg, Wrapper } from './styled-components';

type Props = {
  url: string | null | undefined;
};

export const Banner = ({ url }: Props) => {
  const [css, theme] = useStyletron();

  return (
    <Wrapper>
      {url ? (
        <ResponsiveImage
          alt=""
          src={url}
          sizes={`(min-width: ${theme.breakpoints.xl}) 33.3vw, 95vw`}
          assetWidths={300}
          draggable={false}
          className={css({
            // These styles are applied so that very old banners (without forced aspect ratio) fill
            // the entire container
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          })}
          data-testid="banner"
        />
      ) : (
        <FallbackImg alt="" src={fallbackLight} draggable="false" data-testid="default-banner" />
      )}
    </Wrapper>
  );
};
